import React from "react";
import './index.css';
import './App.css';
import Header from "./Components/Header";
import Home from "./Components/Home";
import About from "./Components/About";
import Services from "./Components/Services";
import Tariff from "./Components/Tariff";
import Contact from "./Components/Contact";
import Footer from "./Components/Footer";
function App() {
  return (
    <div className="App" >
      <Header/>
      <Home/>
      <About/>
      <Services/>
      <Tariff/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;
